export const TOKENS = {
  DefaultOrganizationalContainerSource: '@trustedshops/tswp-core-masterdata:DefaultOrganizationalContainerSource',
  DefaultOrganizationalContainerRenderer: '@trustedshops/tswp-core-masterdata:DefaultOrganizationalContainerRenderer',
  OrganizationalContainerProvider: '@trustedshops/tswp-core-masterdata:OrganizationalContainerProvider',
  OrganizationalContainerSelectionService: '@trustedshops/tswp-core-masterdata:OrganizationalContainerSelectionService',
  FeatureBookingService: '@trustedshops/tswp-core-masterdata:FeatureBookingService',
  ProductFeatureService: '@trustedshops/tswp-core-masterdata:ProductFeatureService',
  OnboardingService: '@trustedshops/tswp-core-masterdata:OnboardingService',
  UserFlowService: '@trustedshops/tswp-core-masterdata:UserFlowService',
  KameleoonService: '@trustedshops/tswp-core-masterdata:KameleoonService',
};
